import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WebGalleryAlbumFolder from './WebGalleryAlbumFolder';
import { AlbumFolderForWebGalleries } from '../../graphql/queries/album-folder';
import { MeQuery } from '../../../../graphql/queries/account';
import withCTAProps from '../ShutterbugCTAOnboardingModal';
import withHierarchyViewsCreate from '../../../../components/global/HiearchyGroups/hoc/withHierarchyViewsCreate';

const withFolderData = graphql(AlbumFolderForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.folderId,
    },
    // Important so that when users sign in from a public web gallery
    // we refetch transparently and show them the correct album folder
    // children (if the album folder has any access groups or other
    // permissions).
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loadingAlbumFolder: loading,
  }),
  skip: ({ match }) => !match.params.folderId,
});

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withFolderData,
  withUserData,
  withHierarchyViewsCreate(({ match }) => match.params.folderId),
  withCTAProps,
)(WebGalleryAlbumFolder);
